module.exports = __webpack_public_path__ + "static/media/card-content-link.83b2abe4.svg";